import { api, saveTokens, clearTokens } from './client';

interface AuthResponse {
  accessToken: string;
  refreshToken: string;
  user: {
    id: string;
    email: string;
    full_name: string;
    role: string;
    tenant_id: string;
    tenant_name: string;
    is_platform_admin: boolean;
  };
}

/**
 * Exchange a Google ID token for an IdeaPilot JWT session.
 * The backend enforces the email allowlist server-side.
 */
export async function googleLogin(idToken: string): Promise<AuthResponse> {
  const data = await api.post<AuthResponse>(
    '/auth/google-login',
    { idToken },
    { skipAuth: true } as RequestInit & { skipAuth?: boolean }
  );
  saveTokens(data);
  return data;
}

export async function fetchMe(): Promise<AuthResponse['user']> {
  return api.get<AuthResponse['user']>('/auth/me');
}

export async function logout(refreshToken?: string): Promise<void> {
  try {
    await api.post('/auth/logout', refreshToken ? { refreshToken } : undefined);
  } finally {
    clearTokens();
  }
}

export type { AuthResponse };
